import { useEffect, useId, useRef, useState } from "react";
import { RiDeleteBack2Line, RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { LuLockKeyhole } from "react-icons/lu";
import "./style.css";

export const PinPad = ({
  callback,
  inputText,
  head = "Acceso a Cocina",
  allowText = false,
  description,
  feedback = "",
}) => {
  const [pin, setPin] = useState("");
  const valueRef = useRef("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [visible, setVisible] = useState(false);
  const pending = useRef(false);
  const helperId = useId();
  const pinInput = useRef(null);
  useEffect(() => {
    if (!allowText) pinInput.current?.focus();
  }, [allowText]);
  const submit = async (value = valueRef.current) => {
    if (pending.current || !value || (!allowText && value.length !== 4)) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      const accepted = await callback(value);
      if (accepted !== false) {
        valueRef.current = "";
        setPin("");
      }
    } catch {
      setError("No se pudo comprobar el acceso. Vuelve a intentarlo.");
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };
  const update = (value) => {
    const next = allowText ? value : value.replace(/\D/g, "").slice(0, 4);
    valueRef.current = next;
    setPin(next);
    setError("");
    if (!allowText && next.length === 4) void submit(next);
  };
  return (
    <section className={`accessiblePinPad ${allowText ? "kdPlatformPassword" : "kdEmployeePin"}`} aria-busy={busy}>
      <div className="kdAccessSymbol" aria-hidden="true">
        <LuLockKeyhole />
      </div>
      <h1 className="loginTitle">{head}</h1>
      {description && <p className="kdAccessIdentity">{description}</p>}
      <p className="kdAccessHint" id={helperId}>
        {inputText}
      </p>
      {(error || feedback) && (
        <p role="alert" className="kdAccessError">
          {error || feedback}
        </p>
      )}
      <form
        onSubmit={(event) => {
          event.preventDefault();
          void submit();
        }}
      >
        {allowText ? (
          <div className="kdPasswordField">
            <label htmlFor={`${helperId}-input`}>Código de acceso a Cocina</label>
            <div>
              <input
                id={`${helperId}-input`}
                type={visible ? "text" : "password"}
                aria-label="Código de plataforma"
                aria-describedby={helperId}
                inputMode="none"
                autoComplete="current-password"
                value={pin}
                disabled={busy}
                onChange={(event) => update(event.target.value)}
              />
              <button
                type="button"
                aria-label={visible ? "Ocultar código" : "Mostrar código"}
                aria-pressed={visible}
                disabled={busy}
                onClick={() => setVisible((value) => !value)}
              >
                {visible ? <RiEyeOffLine /> : <RiEyeLine />}
              </button>
            </div>
          </div>
        ) : (
          <>
            <label className="inputPwd">
              <input
                ref={pinInput}
                className="kdPinInput"
                type="password"
                inputMode="none"
                autoComplete="off"
                maxLength={4}
                aria-label="PIN del empleado"
                aria-describedby={helperId}
                disabled={busy}
                value={pin}
                onChange={(event) => update(event.target.value)}
              />
              <span className="kdPinDots" aria-hidden="true">
                {[0, 1, 2, 3].map((index) => (
                  <span key={index} className={index < pin.length ? "is-filled" : ""} />
                ))}
              </span>
              <span className="visually-hidden" role="status">
                PIN introducido: {pin.length} dígitos
              </span>
            </label>

          </>
        )}
            <div className="pinList" role="group" aria-label="Teclado de acceso">
              {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((value) => (
                <button
                  key={value}
                  type="button"
                  className="cardPin"
                  aria-label={value}
                  disabled={busy}
                  onClick={() => update(valueRef.current + value)}
                >
                  {value}
                </button>
              ))}
              <button
                type="button"
                className="cardPin pinAuxiliary"
                aria-label="Borrar PIN"
                disabled={busy || !pin}
                onClick={() => update("")}
              >
                C
              </button>
              <button
                type="button"
                className="cardPin"
                aria-label="0"
                disabled={busy}
                onClick={() => update(valueRef.current + "0")}
              >
                0
              </button>
              <button
                type="button"
                className="cardPin pinAuxiliary"
                aria-label="Borrar último dígito"
                disabled={busy || !pin}
                onClick={() => update(valueRef.current.slice(0, -1))}
              >
                <RiDeleteBack2Line aria-hidden="true" />
              </button>
            </div>
        <button
          type="submit"
          className="kdAccessPrimary"
          hidden={!allowText && (pin.length !== 4 || busy)}
          aria-label={allowText ? "Continuar a Cocina" : "Confirmar PIN"}
          disabled={busy || !pin || (!allowText && pin.length !== 4)}
        >
          {busy ? "Comprobando acceso…" : allowText ? "Continuar" : "Entrar"}
        </button>
        {busy && (
          <p role="status" className="kdAccessStatus">
            Comprobando acceso…
          </p>
        )}
      </form>
    </section>
  );
};
